import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./StorePurchaseRecipient.scss";

const StorePurchaseRecipient = ({
    displayPurchaseRecipient,
    creditedStorePurchaseTextWithRecipient,
}) =>
    displayPurchaseRecipient && (
        <div className="-padding-top--15 -padding-bottom--15">
            <div className="-callout -padding-bottom--0 -padding-top--0">
                <div className="store-purchase-recipient-container">
                    <Icon
                        className="store-purchase-recipient-icon"
                        glyph="qgiv-store-purchase"
                        type="Custom"
                    />
                    <span className="store-purchase-recipient-text">
                        {creditedStorePurchaseTextWithRecipient}
                    </span>
                </div>
            </div>
        </div>
    );

StorePurchaseRecipient.propTypes = {
    creditedStorePurchaseTextWithRecipient: PropTypes.string.isRequired,
    displayPurchaseRecipient: PropTypes.bool.isRequired,
};

export default StorePurchaseRecipient;
